
<template>
    <div ref="validateCode">
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="16">
                <a-input size="large" type="text" v-model="validateCodeString" placeholder="图形验证码" v-decorator="['validateCodeString', {rules: [{ required: true, message: '请输入图形验证码' }], validateTrigger: 'blur'}]">
                    <a-icon slot="prefix" type="info-circle" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
            </a-col>
            <a-col class="gutter-row" :span="8">
                <img :src="validateCodeUrl" alt="图形验证码" class="code" @click="getValidateCodeUrl">
            </a-col>
        </a-row>
    </div>
</template>

<script>
import { getValidateCode, checkCalidateCode } from '@/api/login'
    export default {
        name:"validateCode",
        data(){
            return {
                validateCodeUrl:"",
                validateCodeString:"",
                codeId:""
            }
        },
        methods: {
            getValidateCodeUrl(){
                getValidateCode({}).then(res=>{
                    if(res.code == 1){
                        this.codeId = res.result.id
                        this.validateCodeUrl = `data:image/jpeg;base64,${res.result.img}`
                        // let blob = new Blob([res], {type:'image/jpeg'})
                        // this.validateCodeUrl = window.URL.createObjectURL(blob)
                    }
                })
            },
            async checkValidateCodeUrl(){
                if(this.validateCodeString == ""){
                    this.$notification['error']({
                        message: '提示',
                        description: '请输入图形验证码',
                        duration: 2
                    })
                    return
                }
                return checkCalidateCode({code:this.validateCodeString,id:this.codeId}).then(res=>{
                    if(res.code==-1){
                        this.getValidateCodeUrl()
                    }
                    return res
                }).catch(err=>{
                    this.getValidateCodeUrl()
                })
            },
        },
        mounted(){
           this.getValidateCodeUrl()
        }
    }
</script>

<style scoped>
.code{
    height: 40px;
    cursor: pointer;
}
.ant-form-item{
    margin-bottom:0 !important;
}
</style>
